/**
 * Category-to-hero-image mapping for article pages.
 * 32 categories mapped to 10 themed hero images.
 */

const HERO_IMAGES = {
  molecular: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/37dec24bafe0a6cfac7f4483e29da681ed46bedc80b380f1c4f2311736798a22.jpeg',
  brain: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/40f6e2d1dcb3c7cf3e06380f4bd799366392c1493c3766e99c1a1d7c6ce3006b.jpeg',
  heart: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/851e2fbc5543467eb7ce2e21ec181ecd47f322553cba13aba0dfcf5fbcdc9bb7.jpeg',
  fitness: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/dcaf5cbc51f97de26e4e61fbd4159f77df0bed84b97e74bd99486076fa912264.jpeg',
  dna: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/d6578ad3ec2037e9eb6fedf307a6990d5f0b427a4e7a0419653919066256cfda.jpeg',
  gut: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/16d5b174f65511b8cf4cba71d620e188308f08cd203e8c7ebbeb9816bd95903e.jpeg',
  metabolism: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/b838843b6fda52313e5dde267f6420407d69bdf3e69b2fe26c26e8ace752ba1f.jpeg',
  immune: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/4039bb5ed9aa0b905892b487107df9a2b27cf6f1b7f9120331329eeee77ba7d4.jpeg',
  skin: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/99e4e985ffe20656e75bffd1eaa39094a34b75a163a318501f1110184a6dca5c.jpeg',
  wellness: 'https://static.prod-images.emergentagent.com/jobs/c04aedfa-d875-4b73-860b-bb9ed10ef5a6/images/bc3a8513765e286738f6923941a31c2c01e82f8f8768523a69843b8845103db5.jpeg',
};

const CATEGORY_IMAGE_MAP = {
  'weight-loss': 'metabolism',
  'fitness': 'fitness',
  'health-wellness': 'wellness',
  'addiction': 'brain',
  'anti-aging': 'dna',
  'copper-peptide-cream': 'skin',
  'anti-inflammatory': 'immune',
  'antioxidants': 'metabolism',
  'autism': 'brain',
  'blood-sugar': 'metabolism',
  'bones': 'fitness',
  'brain-health': 'brain',
  'cancer': 'immune',
  'cardiovascular': 'heart',
  'collagen': 'skin',
  'dementia': 'brain',
  'energy': 'metabolism',
  'eyes': 'wellness',
  'fertility': 'wellness',
  'glp': 'metabolism',
  'growth-hormone': 'dna',
  'gut': 'gut',
  'hair': 'skin',
  'heart': 'heart',
  'hgh': 'dna',
  'immunity': 'immune',
  'joints': 'fitness',
  'liver': 'gut',
  'mental-health': 'brain',
  'metabolism': 'metabolism',
  'recovery': 'fitness',
  'sleep': 'wellness',
};

export function getHeroImage(categorySlug) {
  const theme = CATEGORY_IMAGE_MAP[categorySlug] || 'molecular';
  return HERO_IMAGES[theme] || HERO_IMAGES.molecular;
}

export function getCategoryTheme(categorySlug) {
  return CATEGORY_IMAGE_MAP[categorySlug] || 'molecular';
}

export default HERO_IMAGES;
